import { DateTime } from 'luxon'

export class Shift {
  data: TShiftData

  constructor(shiftData: TShiftData) {
    this.data = shiftData
  }

  get startDate(): DateTime | undefined {
    return this.data.startDate
      ? DateTime.fromISO(this.data.startDate)
      : undefined
  }

  get endDate(): DateTime | undefined {
    return this.data.endDate ? DateTime.fromISO(this.data.endDate) : undefined
  }

  get duration(): number {
    return this.data.durationInHours ?? 0
  }

  get isUpcoming(): boolean {
    const now = DateTime.now()
    return this.startDate ? this.startDate > now : false
  }

  get isNew(): boolean {
    return this.data.isNew ?? false
  }

  get isActive(): boolean {
    const now = DateTime.now()
    return (
      this.startDate !== undefined &&
      this.endDate !== undefined &&
      now >= this.startDate &&
      now <= this.endDate
    )
  }

  get isPast(): boolean {
    const now = DateTime.now()
    return this.endDate ? this.endDate < now : false
  }

  toJSON(): TShiftData {
    return this.data
  }

  static createFromServerObject(shift: TServerShift): Shift {
    return new Shift({
      id: shift.id,
      startDate: shift.startDate,
      endDate: shift.endDate,
      durationInHours: shift.durationInHours,
      name: shift.name ?? undefined,
      color: shift.color ?? undefined,
      description: shift.description ?? undefined,
      attachments: shift.attachments ?? [],
      employees: shift.employees ?? [],
      maxEmployees: shift.maxEmployees ?? undefined,
      changedFields: shift.changedFields ?? [],
      placeId: shift.placeId,
      placeName: shift.placeName,
      revisionId: shift.revisionId,
      planId: shift.planId,
      planName: shift.planName ?? undefined,
      planDescription: shift.planDescription ?? undefined,
      // e.g. [
      //   {
      //     name: 'Sicherheitsunterweisung_1_2024.pdf',
      //     url: 'https://www.url-zum-attachment.de/',
      //   },
      //   {
      //     name: 'Sicherheitsunterweisung_2_2024.pdf',
      //     url: 'https://www.url-zum-attachment.de/',
      //   },
      // ]
      planAttachments: shift.planAttachments ?? [],
      isNew: shift.isNew,
    })
  }

  static createFromObject(shiftData: TShiftData): Shift {
    return new Shift(shiftData)
  }
}

export type TServerShift = {
  id?: number
  startDate?: string
  endDate?: string
  durationInHours?: number
  name?: string | null
  color?: string | null
  description?: string | null
  attachments?: Array<Record<string, string>>
  employees?: Array<TShiftEmployee>
  maxEmployees?: number
  changedFields?: Array<string>
  placeId?: number
  placeName?: string
  revisionId?: number
  planId?: number
  planName?: string | null
  planDescription?: string | null
  planAttachments?: Array<Record<string, string>>
  isNew?: boolean
}

export type TShiftEmployee = {
  id?: number
  employeeId?: number
  name?: string
  status?: string
}

export type TShiftData = {
  id?: number
  startDate?: string
  endDate?: string
  durationInHours?: number
  name?: string
  color?: string
  description?: string
  attachments?: Array<Record<string, string>>
  employees?: Array<TShiftEmployee>
  maxEmployees?: number
  changedFields?: Array<string>
  isNew?: boolean
  placeId?: number
  placeName?: string
  revisionId?: number
  planId?: number
  planName?: string
  planDescription?: string
  planAttachments?: Array<Record<string, string>>
}
